/**
 * @class Modal
 * 
 * @method constructor
 *     @param {HTMLElement} el
 * 
 * @method toggleModal
 * @method init
 *
 * Create a modal
 */

const selectors = {
    close: '.js-modal-close'
}

const classes = {
    open: 'is-open',
    visible: 'is-visible',
    locked: 'is-locked'
}

export default class Modal {
    constructor (el) {
        this.el = el;
        this.close = el.querySelector(selectors.close);
        this.trigger = document.querySelector(`[data-modal-trigger="${this.el.id}"]`);

        this.isOpen = false;

        this.init();
    }

    toggleModal (isOpen) {
        if (isOpen && !this.isOpen) {
            this.openModal();
        } else if (!isOpen && this.isOpen) {
            this.closeModal();
        }
        
        this.isOpen = isOpen;
    }

    openModal () {
        this.el.classList.add(classes.open);
        this.el.setAttribute('aria-hidden', false);
        document.body.classList.add(classes.locked);
        this.isOpen = true;

        requestAnimationFrame(() => {
            this.el.classList.add(classes.visible);
        });
    }

    closeModal () {
        this.el.classList.remove(classes.visible);
        this.isOpen = false;

        setTimeout(() => {
            this.el.classList.remove(classes.open);
            this.el.setAttribute('aria-hidden', true);
            document.body.classList.remove(classes.locked);
        }, 500);
    }

    init () {
        this.close.addEventListener('click', () => this.closeModal());

        window.addEventListener('keyup', e => {
            if (e.key === 'Escape') this.closeModal();
        });

        if (!this.trigger) return;
        this.trigger.addEventListener('click', () => {
            this.openModal();
        });
        
        window.addEventListener('click', e => {
            const isOutsideTrigger = this.trigger ? e.target !== this.trigger : false;
            const isOutsideModal = e.target !== this.el && !this.el.contains(e.target);
            if (isOutsideTrigger && isOutsideModal && this.isOpen) this.closeModal();
        });
    }
}
